export default {

	//js精度计算 f代表需要计算的表达式，digit代表小数位数
	MathformatFloat: function(f, digit) {
		// Math.pow(指数，幂指数)
		var m = Math.pow(10, digit);
		// Math.round（） 四舍五入
		return Math.round(f * m, 10) / m;
	},

	//计算两个日期的天数
	getDaysBetween: function(startdate, enddate) {
		let days = 0;
		var startDate = Date.parse(startdate);
		var endDate = Date.parse(enddate);
		if (startDate > endDate) {
			days = 0;
		}
		if (startDate == endDate) {
			days = 1;
		}
		days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
		if (isNaN(days)) {
			days = 0;
		}
		return days;
	},

	//多维数组转一维数据
	flatten(arr) {
		return [].concat(...arr.map(x => Array.isArray(x) ? this.flatten(x) : x))
	},

	//时间转换 xxx-xx-xx
	dateFormat: function(date, fmt) {
		let ret;
		const opt = {
			"Y+": date.getFullYear().toString(), // 年
			"m+": (date.getMonth() + 1).toString(), // 月
			"d+": date.getDate().toString(), // 日
			"H+": date.getHours().toString(), // 时
			"M+": date.getMinutes().toString(), // 分
			"S+": date.getSeconds().toString(), // 秒
			"Mi+": date.getMilliseconds().toString() // 秒
			// 有其他格式化字符需求可以继续添加，必须转化成字符串
		}
		for (let k in opt) {
			ret = new RegExp("(" + k + ")").exec(fmt);
			if (ret) {
				fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
			}
		}
		return fmt;
	},

	//时间转换 xxxx年xx月xx日
	timeTrans: function(time) {
		var date = new Date(time)
		var year = date.getFullYear()
		var month = date.getMonth() + 1
		var day = date.getDate()
		return year + '年' + month + '月' + day + '日'
	},

	//数字转中文大写
	intToChinese: function(money) {
		var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
		var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
		var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
		var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
		var cnInteger = "整"; //整数金额时后面跟的字符
		var cnIntLast = "元"; //整型完以后的单位
		var maxNum = 999999999999999.9999; //最大处理的数字
		var IntegerNum; //金额整数部分
		var DecimalNum; //金额小数部分
		var ChineseStr = ""; //输出的中文金额字符串
		var parts; //分离金额后用的数组，预定义    
		var Symbol = ""; //正负值标记
		if (money == "") {
			return "";
		}

		money = parseFloat(money);
		if (money >= maxNum) {
			alert('超出最大处理数字');
			return "";
		}
		if (money == 0) {
			ChineseStr = cnNums[0] + cnIntLast + cnInteger;
			return ChineseStr;
		}
		if (money < 0) {
			money = -money;
			Symbol = "负 ";
		}
		money = money.toString(); //转换为字符串
		if (money.indexOf(".") == -1) {
			IntegerNum = money;
			DecimalNum = '';
		} else {
			parts = money.split(".");
			IntegerNum = parts[0];
			DecimalNum = parts[1].substr(0, 4);
		}
		if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
			var zeroCount = 0;
			var IntLen = IntegerNum.length;
			for (var i = 0; i < IntLen; i++) {
				var n = IntegerNum.substr(i, 1);
				var p = IntLen - i - 1;
				var q = p / 4;
				var m = p % 4;
				if (n == "0") {
					zeroCount++;
				} else {
					if (zeroCount > 0) {
						ChineseStr += cnNums[0];
					}
					zeroCount = 0; //归零
					ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
				}
				if (m == 0 && zeroCount < 4) {
					ChineseStr += cnIntUnits[q];
				}
			}
			ChineseStr += cnIntLast;
			//整型部分处理完毕
		}
		if (DecimalNum != '') { //小数部分
			var decLen = DecimalNum.length;
			for (var j = 0; j < decLen; j++) {
				var dn = DecimalNum.substr(j, 1);
				if (dn != '0') {
					ChineseStr += cnNums[Number(dn)] + cnDecUnits[j];
				}
			}
		}
		if (ChineseStr == '') {
			ChineseStr += cnNums[0] + cnIntLast + cnInteger;
		} else if (DecimalNum == '') {
			ChineseStr += cnInteger;
		}
		ChineseStr = Symbol + ChineseStr;

		return ChineseStr;
	},


	//数字处理
	digitalprocessing: function(val) {
		if (val == undefined || isNaN(val)) {
			return 0;
		} else {
			let value = parseFloat(val);
			if (isNaN(value)) {
				return 0;
			}
			return value;
		}
	},

	//计算对象数组中某个属性合计
	countTotal: function(arr, keyName) {
		let total = 0;
		arr.map(function(item) {
			total += parseFloat(item[keyName]) ? parseFloat(item[keyName]) : 0;
		});
		return this.MathformatFloat(total, 2).toFixed(2);
	},

	//下载文件
	downloadFile(url) {
		let data = {
			"status": false,
			"message": "文件下载失败",
		}
		try {
			url = url.replace(/\\/g, "/");
			const xhr = new XMLHttpRequest();
			xhr.open("GET", url, true);
			xhr.responseType = "blob";
			xhr.onload = () => {
				if (xhr.status === 200) {
					//获取文件blob数据并保存
					var num = url.lastIndexOf("/") + 1;
					//把参数和文件名分隔开
					var fileName = url.substring(num).split("?")[0];
					var export_blob = new Blob([xhr.response]);
					const save_link = document.createElement("a");
					save_link.href = URL.createObjectURL(export_blob);
					save_link.download = fileName;
					save_link.click();
					data.status = true;
					data.message = "文件下载成功";
				}
			};
			xhr.send();
		} catch (e) {
			data.status = false;
			data.message = "附件下载失败:" + e.toString();
		}
		return data;
	},

	//获取当前数据的下标
	getdataindex(data, obj) {
		var i = data.length;
		while (i--) {
			if (data[i] === obj) {
				return i;
			}
		}
		return -1;
	},

	//计算时间范围
	calcuRangeTime(month) {
		let currTime = [];
		if (month == undefined || month == "") {
			return currTime;
		}
		let now = new Date();
		let currDate = this.dateFormat(now, "YYYY-mm-dd");

		let preMonthTime = now.setMonth(now.getMonth() + month);
		var preTime = new Date(preMonthTime);
		let preData = this.dateFormat(preTime, "YYYY-mm-dd");

		currTime.push(preData);
		currTime.push(currDate);
		return currTime;
	},

	//生成int随机数
	getRandomInt(min, max) {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}


}